import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconArrow = styled(SvgIcon).attrs({
  viewBox: '0 0 1024 1024',
  children: ({ color }: { color: string }) => (
    <>
      <defs />
      <path
        fill={color}
        d="M877.248 429.248 512 794.496 146.752 429.248l90.496-90.496L512 613.504l274.752-274.752 90.496 90.496z"
      />
    </>
  ),
})``;

export default IconArrow;
